// All action times

const managePlans = {
  REQUEST_VALIDATION: 'REQUEST_VALIDATION',
  RECEIVE_VALIDATION: 'RECEIVE_VALIDATION',
  REQUEST_RESET: 'REQUEST_RESET',
  RECEIVE_RESET: 'RECEIVE_RESET',
  LINK_EXPIRED: 'LINK_EXPIRED'
}

export default managePlans



// WEBPACK FOOTER //
// ./src/routes/ResetPassword/actions/actionTypes.js